<span mat-dialog-title>{{'shared.dialogs.confirm.shortLabel' | translate}}</span>
<mat-dialog-content>
    <p>
        {{passedData.message}} <br>
        {{'shared.dialogs.confirm.fullLabel' | translate}}
    </p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">{{'shared.dialogs.confirmYes.shortLabel' | translate}}</button>
    <button mat-raised-button [mat-dialog-close]="false" color="primary">{{'shared.dialogs.confirmNo.shortLabel' | translate}}</button>
</mat-dialog-actions>
